import React from 'react';
import { Document, Image, Page, Text, View, StyleSheet } from '@react-pdf/renderer';

const IVA_ALIQUOTA = 0.081;

const DATI_AZIENDA = {
  nome: 'C.R.G. Scavi e trasporti Sagl',
  indirizzo: 'Via Livio 5, 6830 Chiasso TI',
  contatti: 'Tel. +41 78 751 32 51 - email: info@crgscavi.ch',
  iva: 'IVA: CHE-285.549.695',
};

const pdfStyles = StyleSheet.create({
  page: { padding: 30, fontSize: 10, fontFamily: 'Helvetica' },
  intestazione: { flexDirection: 'row', alignItems: 'center', marginBottom: 16, paddingBottom: 10, borderBottom: '1 solid #ccc' },
  logoImg: { width: 80, height: 32, objectFit: 'contain' },
  recapiti: { marginLeft: 12, fontSize: 9, color: '#333' },
  recapitiNome: { fontSize: 10, fontWeight: 'bold', marginBottom: 2 },
  intestazioneRigheContainer: { flexDirection: 'row', justifyContent: 'space-between', marginBottom: 44 },
  blocSinistra: { width: '45%' },
  blocDestra: { width: '45%' },
  label: { fontWeight: 'bold' },
  titolo: { fontSize: 16, fontWeight: 'bold', textAlign: 'center', marginBottom: 16 },
  cantiereRiga: { backgroundColor: '#eee', padding: 6, marginBottom: 8, fontWeight: 'bold' },
  tableHeader: { flexDirection: 'row', backgroundColor: '#1a1a1a', padding: 5, color: '#fff', fontWeight: 'bold' },
  tableRow: { flexDirection: 'row', padding: 5, borderBottom: '1 solid #ccc' },
  colBolla: { width: '11%', paddingRight: 6 },
colBolla: { width: '11%', paddingRight: 6 },
colData: { width: '13%' },
colDescr: { width: '26%' },
colUnita: { width: '8%' },
colQta: { width: '10%' },
colPrezzo: { width: '8%' },
colSconto: { width: '8%', textAlign: 'right' },
colTotale: { width: '14%', textAlign: 'right' },
  totaliBox: { marginTop: 16, alignSelf: 'flex-end', width: '45%' },
  totaliRiga: { flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 2 },
totaliRigaFinale: { flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 4, borderTop: '1 solid #333', marginTop: 4, fontWeight: 'bold', fontSize: 12 },
condizioniBox: { marginTop: 20, width: '55%' },
condizioniRiga: { flexDirection: 'row', marginBottom: 4 },
condizioniLabel: { fontWeight: 'bold', width: 150 },
qrCodeImg: { width: 110, height: 110, marginTop: 6 },
});

function fmtDataIT(isoDate) {
  if (!isoDate) return '';
  const parts = isoDate.split('-');
  if (parts.length !== 3) return isoDate;
  return `${parts[2]}.${parts[1]}.${parts[0]}`;
}

function fmtCHF(numero) {
  const n = Number(numero) || 0;
  const negativo = n < 0;
  const numeroAbs = Math.abs(n).toFixed(2);
  const [parteIntera, parteDecimale] = numeroAbs.split('.');
  const parteInteraFormattata = parteIntera.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  return (negativo ? '-' : '') + parteInteraFormattata + '.' + parteDecimale;
}

export default function FatturaPDF({ fattura, cliente, cantiere }) {
  const {
    numeroFattura, dataFattura,
    righe, scontoPercento, subtotale, imponibile, iva, totale,
    modalitaPagamento, datiBancari,
  } = fattura;

  return (
    <Document>
      <Page size="A4" style={pdfStyles.page}>
        <View style={pdfStyles.intestazione}>
          <Image src="/CRG_logo.png" style={pdfStyles.logoImg} />
          <View style={pdfStyles.recapiti}>
            <Text style={pdfStyles.recapitiNome}>{DATI_AZIENDA.nome}</Text>
            <Text>{DATI_AZIENDA.indirizzo}</Text>
            <Text>{DATI_AZIENDA.contatti}</Text>
            <Text>{DATI_AZIENDA.iva}</Text>
          </View>
        </View>

        <Text style={pdfStyles.titolo}>FATTURA</Text>

        <View style={pdfStyles.intestazioneRigheContainer}>
          <View style={pdfStyles.blocSinistra}>
            <Text><Text style={pdfStyles.label}>Chiasso, </Text>{fmtDataIT(dataFattura)}</Text>
            <Text><Text style={pdfStyles.label}>Fattura N°: </Text>{numeroFattura}</Text>
          </View>
          <View style={pdfStyles.blocDestra}>
            <Text style={pdfStyles.label}>Spett.le</Text>
            <Text style={{ marginBottom: 12 }}>{cliente?.ragioneSociale || ''}</Text>
            {cliente?.indirizzo ? <Text>{cliente.indirizzo}</Text> : null}
            {(cliente?.cap || cliente?.citta) ? (
              <Text>{[cliente.cap, cliente.citta].filter(Boolean).join(' ')}</Text>
            ) : null}
          </View>
        </View>

        {cantiere ? (
          <Text style={pdfStyles.cantiereRiga}>Cantiere: {cantiere.luogo}</Text>
        ) : null}

<View style={pdfStyles.tableHeader}>
  <Text style={pdfStyles.colBolla}>Bolla / Prev.</Text>
  <Text style={pdfStyles.colData}>Data</Text>
  <Text style={pdfStyles.colDescr}>Descrizione</Text>
  <Text style={pdfStyles.colUnita}>U</Text>
  <Text style={pdfStyles.colQta}>Q.tà</Text>
  <Text style={pdfStyles.colPrezzo}>Prezzo CHF</Text>
  <Text style={pdfStyles.colSconto}>Sconto %</Text>
  <Text style={pdfStyles.colTotale}>Totale CHF</Text>
</View>

{righe.map((r, i) => (
  <View key={i} style={pdfStyles.tableRow}>
    <Text style={pdfStyles.colBolla}>
      {r.daPreventivo && r.numeroPreventivo
        ? `Prev. ${r.numeroPreventivo}`
        : r.numeroBolla
          ? `Bolla ${r.numeroBolla}`
          : '-'}
    </Text>
    <Text style={pdfStyles.colData}>{fmtDataIT(r.data)}</Text>
    <Text style={pdfStyles.colDescr}>{r.descrizione}</Text>
    <Text style={pdfStyles.colUnita}>{r.unita}</Text>
    <Text style={pdfStyles.colQta}>{r.quantita}</Text>
    <Text style={pdfStyles.colPrezzo}>{fmtCHF(r.prezzo)}</Text>
    <Text style={pdfStyles.colSconto}>
      {r.scontoRiga ? `${r.scontoRiga}%` : '-'}
    </Text>
    <Text style={pdfStyles.colTotale}>{fmtCHF(r.totale)}</Text>
  </View>
))}

        <View style={pdfStyles.totaliBox}>
          <View style={pdfStyles.totaliRiga}>
            <Text>Subtotale</Text>
            <Text>CHF {fmtCHF(subtotale)}</Text>
          </View>
          {scontoPercento > 0 && (
            <View style={pdfStyles.totaliRiga}>
              <Text>Sconto {scontoPercento}%</Text>
              <Text>- CHF {fmtCHF(subtotale - imponibile)}</Text>
            </View>
          )}
          <View style={pdfStyles.totaliRiga}>
            <Text>Imponibile</Text>
            <Text>CHF {fmtCHF(imponibile)}</Text>
          </View>
          <View style={pdfStyles.totaliRiga}>
            <Text>IVA 8.1%</Text>
            <Text>CHF {fmtCHF(iva)}</Text>
          </View>
          <View style={pdfStyles.totaliRigaFinale}>
            <Text>TOTALE</Text>
            <Text>CHF {fmtCHF(totale)}</Text>
          </View>
        </View>

<View style={pdfStyles.condizioniBox}>
  {modalitaPagamento ? (
    <View style={pdfStyles.condizioniRiga}>
      <Text style={pdfStyles.condizioniLabel}>Modalità di pagamento:</Text>
      <Text>{modalitaPagamento}</Text>
    </View>
  ) : null}
  {datiBancari ? (
    <View style={pdfStyles.condizioniRiga}>
      <Text style={pdfStyles.condizioniLabel}>Dati bancari:</Text>
      <Text>{datiBancari}</Text>
    </View>
  ) : null}
  {datiBancari && datiBancari.startsWith('Raiffeisen') ? (
    <Image src="/qr-code-crg-raiffeisen.png" style={pdfStyles.qrCodeImg} />
  ) : null}
</View>
      </Page>
    </Document>
  );
}